// extracted by mini-css-extract-plugin
module.exports = {"UploadImageContainer":"uploadImage_UploadImageContainer__Ho5eB","slideUp":"uploadImage_slideUp__ZusDv","QrWrapper":"uploadImage_QrWrapper__lKL2o"};